module.exports = __webpack_public_path__ + "static/media/bmv.75a77769.png";